import HistoryFilterItem from './HistoryFilterItem';
import { useState } from 'react';

const css = {
  filterContainer: {height: 'fit-content', padding: '10px', margin: '10px', position: 'absolute', zIndex: '99'},
  filterContent: {display: 'flex', flexDirection: 'column'}
}

const HistoryFilter = (props) => {
  const [listFilters, setListFilters] = useState(props.listFilters);
  const [selectedStatus, setSelectedStatus] = useState([]);
  const handleFilter = (status) => {
    status = status.split(',').map(Number);

    if (JSON.stringify(status) === JSON.stringify(selectedStatus)) {
      setSelectedStatus([]);
      props.onClickFilter('*');
      return;
    }

    props.listFilters.map((filter) => {
      filter.filterSelected = JSON.stringify(filter.statusTarget) === JSON.stringify(status);
      return filter;
    });
    setListFilters([...props.listFilters]);
    setSelectedStatus(status);
    props.onClickFilter(status);
  }

  return (
    <div style={css.filterContainer}>
      <div>{props.title}</div>
      <div style={css.filterContent}>
        <ul>
          {listFilters.map((filter, index) => {
            return (
              <HistoryFilterItem
                filter={filter}
                onSelected={handleFilter}
                key={index}
              />
            )
          })}
        </ul>
      </div>
    </div>
  );
}

export default HistoryFilter;